import { render, staticRenderFns } from "./Beymen.vue?vue&type=template&id=5e797ec3&scoped=true"
import script from "./Beymen.vue?vue&type=script&lang=js"
export * from "./Beymen.vue?vue&type=script&lang=js"
import style0 from "./Beymen.vue?vue&type=style&index=0&id=5e797ec3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e797ec3",
  null
  
)

export default component.exports